// extracted by mini-css-extract-plugin
export default {"container":"LabelValue_container__N2DtQ","label":"LabelValue_label__fD7L8","value":"LabelValue_value__TWtyX"};